import React from "react";

export interface IconBaseProps {
  className?: string;
  size?: number;
  color?: string;
  strokeWidth?: number;
  title?: string;
}

interface Props extends IconBaseProps {
  children: React.ReactNode;
  viewBox?: string;
}

export const IconBase = ({
  children,
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  viewBox = "0 0 24 24",
  title,
}: Props) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : true}
      role={title ? "img" : undefined}
    >
      {title && <title>{title}</title>}
      {children}
    </svg>
  );
};
